import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import type ScheduledReportSpecificationSchedule from "shared/resources/ScheduledReportSpecificationSchedule";
import {
  ApplicationRecord,
  objectDirtyChecker,
} from "shared/services/spraypaint";
import { type Nullable } from "shared/types";

import type InstantInsightsReport from "./InstantInsightsReport";
import type OrganisationBrand from "./OrganisationBrand";
import type User from "./User";

@Model()
class InsightsScheduledSpecification extends ApplicationRecord {
  static jsonapiType = "insights_scheduled_specifications";

  @Attr() completedAt: string;

  @Attr() createdAt: string;

  @Attr() description: string;

  @Attr() enabled: boolean;

  @Attr() hideKeyInsightsPages: boolean;

  @BelongsTo() instantInsightsReport: InstantInsightsReport;

  @Attr() instantInsightsReportId: number;

  @Attr() language: string;

  @BelongsTo() organisationBrand: OrganisationBrand;

  @Attr() organisationBrandId: Nullable<number>;

  @Attr() productType: "insights";

  @Attr({ dirtyChecker: objectDirtyChecker }) recipients: string[];

  @HasMany() schedules: ScheduledReportSpecificationSchedule[];

  @Attr() subject: string;

  @Attr() title: string;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default InsightsScheduledSpecification;
